import { render, staticRenderFns } from "./logReiDtl.vue?vue&type=template&id=4b838b5e&scoped=true&"
import script from "./logReiDtl.vue?vue&type=script&lang=js&"
export * from "./logReiDtl.vue?vue&type=script&lang=js&"
import style0 from "./logReiDtl.vue?vue&type=style&index=0&id=4b838b5e&prod&lang=scss&scoped=true&"
import style1 from "./logReiDtl.vue?vue&type=style&index=1&id=4b838b5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b838b5e",
  null
  
)

export default component.exports